import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Box from '../atoms/Box';
import Text from '../atoms/Text';
import LocationPin from '../atoms/icons/LocationPin';
import Stopwatch from '../atoms/icons/Stopwatch';

const StyledCard = styled('div')({
  position: 'relative',
  borderRadius: '8px',
  background: 'rgba(255, 255, 255, 0.75)',
  backdropFilter: 'blur(12px)',
  marginRight: '16px',
  boxShadow: '0 10px 40px 0 rgba(64,64,64,0.10)',
  overflow: 'hidden',
  display: 'inline-block'
});

const MinimalMissionCard = ({ title, skill1, skill1Level, skill2Level, skill2 }) => {
  return (
    <StyledCard>
      <Box display="flex" wrap="nowrap" px="3" alignItems="center" py="1">
        <LocationPin fontSize="8px" color="#B3B3B3" />
        <Box bg="#f1f1f1" height="2px" width="57px" ml="1" mr="2" />
        <Stopwatch fontSize="8px" color="#B3B3B3" />
        <Box bg="#f1f1f1" height="2px" width="57px" ml="1" />
      </Box>
      <Box bg="#f1f1f1" height="1px" width="100%" />
      <Text fontWeight="800" fontSize="14px" my="2" px="2">
        {title}
      </Text>
      <Box display="flex" wrap="nowrap" px="2" mb="2">
        <Box border="2px solid #F1F1F1" borderRadius="56px" pl="2" whiteSpace="nowrap" mr={1}>
          {skill1} <Box borderTopLeftRadius="0" borderTopRightRadius="56px" borderBottomLeftRadius="0" borderBottomRightRadius="56px" bg="#f1f1f1" display="inline-block" px="1" ml={1}>{skill1Level}</Box>
        </Box>
        <Box border="2px solid #F1F1F1" borderRadius="56px" pl="2" whiteSpace="nowrap">
          {skill2} <Box borderTopLeftRadius="0" borderTopRightRadius="56px" borderBottomLeftRadius="0" borderBottomRightRadius="56px" bg="#f1f1f1" display="inline-block" px="1" ml={1}>{skill2Level}</Box>
        </Box>
      </Box>
    </StyledCard>
  );
};

MinimalMissionCard.propTypes = {
  title: PropTypes.string,
  skill1: PropTypes.string,
  skill2: PropTypes.string,
  skill1Level: PropTypes.number,
  skill2Level: PropTypes.number
};

export default MinimalMissionCard;